import { render, staticRenderFns } from "./tripdays.vue?vue&type=template&id=1213829d"
import script from "./tripdays.vue?vue&type=script&lang=js"
export * from "./tripdays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports